<template>
  <div class="edit-product">
    <KTCodePreview v-bind:title="''">
      <template v-slot:preview>
        <v-form ref="form" lazy-validation>
          <b-card no-body class="full-width">
            <div>
              <!--begin: Wizard-->
              <div
                class="wizard wizard-4"
                id="kt_wizard_v4"
                data-wizard-state="step-first"
                data-wizard-clickable="true"
              >
                <!--begin: Wizard Nav-->
                <div class="wizard-nav" style="background-color: #eef0f8">
                  <div class="wizard-steps">
                    <div
                      class="wizard-step"
                      data-wizard-type="step"
                      data-wizard-state="current"
                    >
                      <div class="wizard-wrapper">
                        <div class="wizard-label">
                          <div class="wizard-title">Thông tin chung</div>
                        </div>
                      </div>
                    </div>
                    <!-- <div
                      class="wizard-step ml-1"
                      data-wizard-type="step"
                      v-show="showCombo"
                    >
                      <div class="wizard-wrapper">
                        <div class="wizard-label">
                          <div class="wizard-title">Sản phẩm Combo</div>
                        </div>
                      </div>
                    </div> -->
                    <!-- <div class="wizard-step ml-1" data-wizard-type="step">
                      <div class="wizard-wrapper">
                        <div class="wizard-label">
                          <div class="wizard-title">Bảo hành & vận chuyển</div>
                        </div>
                      </div>
                    </div> -->

                    <!--begin: History-->
                    <!-- <div class="wizard-step ml-1" data-wizard-type="step">
                      <div class="wizard-wrapper">
                        <div class="wizard-label">
                          <div class="wizard-title">Lịch sử</div>
                        </div>
                      </div>
                    </div> -->
                    <!--end: History-->
                  </div>
                </div>
                <!--end: Wizard Nav -->

                <!--begin: Wizard Body-->
                <div class="card card-custom card-shadowless rounded-top-0">
                  <div class="card-body p-0">
                    <div class="row py-8 px-8 py-lg-15 px-lg-10">
                      <div class="col-xl-12">
                        <!--begin: Wizard Form-->
                        <form class="form mt-0" id="kt_form">
                          <!--begin: Thông tin chung-->
                          <div
                            class="pb-5 full-width"
                            data-wizard-type="step-content"
                            data-wizard-state="current"
                          >
                            <div class="col-md-12 full-width">
                              <b-row>
                                <b-col>
                                  <h4 style="color: rgb(24, 28, 50)">
                                    Thông tin sản phẩm
                                  </h4>

                                  <b-form-group class="required-control">
                                    <label class="mt-4">ID Sản phẩm:</label>
                                    <b-form-input
                                      size="sm"
                                      v-model="idSync"
                                      placeholder="ID Sản Phẩm"
                                      class="text-left"
                                      :disabled="true"
                                    ></b-form-input>
                                  </b-form-group>
                                  <b-form-group class="required-control">
                                    <label class="mt-1"> Tên sản phẩm: </label>
                                    <b-form-input
                                      size="sm"
                                      v-model="$v.form.name.$model"
                                      :state="validateState('name')"
                                      placeholder="Nhập tên"
                                      @change="genChildProduct"
                                    ></b-form-input>
                                    <b-form-invalid-feedback>
                                      Yêu cầu nhập tên sản phẩm.
                                    </b-form-invalid-feedback>
                                  </b-form-group>
                                  <b-form-group>
                                    <label
                                      class="d-flex justify-content-between"
                                    >
                                      <span
                                        >Mã sản phẩm:
                                        <span class="text-danger">*</span></span
                                      >
                                      <span class="d-inline-block ml-auto">
                                        <i
                                          v-if="!isEditedProductCode"
                                          class="fas fa-lock text-danger icon-size-1-rem"
                                          v-b-tooltip.html.hover.top
                                          title="Mã không được chỉnh sửa. Nếu cần chỉnh sửa, vui lòng liên hệ phòng <b>Kế toán</b>"
                                        ></i>
                                        &nbsp;
                                      </span></label
                                    >
                                    <b-form-input
                                      size="sm"
                                      type="text"
                                      v-model="$v.form.code.$model"
                                      placeholder="Nhập mã sản phẩm"
                                      :state="validateState('code')"
                                      class="mt-1"
                                      @change="genChildProduct"
                                      @keydown.space.prevent
                                      :disabled="!isEditedProductCode"
                                    ></b-form-input>
                                    <b-form-invalid-feedback
                                      v-if="!$v.form.code.required"
                                      >Yêu cầu nhập Mã sản
                                      phẩm.</b-form-invalid-feedback
                                    >
                                    <b-form-invalid-feedback
                                      v-if="!$v.form.code.maxLength"
                                      >Vui lòng nhập Mã sản phẩm nhỏ hơn 50 kí
                                      tự.</b-form-invalid-feedback
                                    >
                                    <b-form-invalid-feedback
                                      v-if="!$v.form.code.minLength"
                                      >Vui lòng nhập Mã sản phẩm lớn hơn 3 kí
                                      tự.</b-form-invalid-feedback
                                    >
                                    <b-form-invalid-feedback
                                      v-if="!$v.form.code.hasSpecialCharacters"
                                      >Mã sản phẩm không được phép chứa khoảng
                                      trắng và các ký tự đặc biệt:
                                      <span
                                        class="font-weight-bolder bg-light-danger"
                                      >
                                        '`~!@#$%^&amp;*(),;"&lt;&gt;?/\,_
                                      </span></b-form-invalid-feedback
                                    >
                                    <b-form-invalid-feedback
                                      v-if="!$v.form.code.checkAscent"
                                      >Mã sản phẩm không được nhập có
                                      dấu</b-form-invalid-feedback
                                    >
                                  </b-form-group>
                                  <!-- 
                                  <b-form-group label="Mã vạch sản phẩm:">
                                    <b-form-input
                                      size="sm"
                                      type="text"
                                      v-model="barcode"
                                      placeholder="Nhập mã vạch sản phẩm"
                                    ></b-form-input>
                                  </b-form-group>

                                  <b-form-group label="Sản phẩm cha:">
                                    <Autosuggest
                                      :model="selectedParent"
                                      :suggestions="filteredOptions"
                                      placeholder="sản phẩm cha"
                                      :limit="10"
                                      @select="onSelected"
                                      @change="onInputChange"
                                      suggestionName="suggestionName"
                                    />
                                  </b-form-group> -->
                                  <b-form-group>
                                    <label
                                      >Danh mục sản phẩm:
                                      <span class="text-danger">*</span>
                                    </label>
                                    <!-- <Autosuggest
                                      class="mt-1"
                                      :model="$v.form.selectedCate.$model"
                                      :suggestions="filteredCateOptions"
                                      :placeholder="'danh mục sản phẩm'"
                                      @select="onSelectedCate"
                                      @change="onInputCateChange"
                                      :state="validateState('selectedCate')"
                                      errorMessages="Yêu cầu chọn danh mục sản phẩm."
                                      suggestionName="suggestionName"
                                    /> -->

                                    <treeselect
                                      :options="filteredCateOptions"
                                      :multiple="false"
                                      placeholder="Chọn danh mục"
                                      :match-keys="['id', 'name']"
                                      :normalizer="normalizerCate"
                                      v-model="selectedCateId"
                                      :clearable="true"
                                      :show-count="true"
                                      openDirection="bottom"
                                    >
                                    </treeselect>
                                  </b-form-group>
                                  <!-- 
                                  <b-form-group class="required-control">
                                    <label>Danh mục nội bộ:</label>
                                    <Autosuggest
                                      class="mt-1"
                                      :model="
                                        $v.form.selectedExternalCate.$model
                                      "
                                      :suggestions="filteredExternalCateOptions"
                                      :placeholder="'danh mục nội bộ'"
                                      @select="onSelectedExternalCate"
                                      @change="onInputExternalCateChange"
                                      :state="
                                        validateState('selectedExternalCate')
                                      "
                                      errorMessages="Yêu cầu chọn danh mục nội bộ."
                                      suggestionName="suggestionName"
                                    />
                                  </b-form-group> -->

                                  <b-form-group
                                    label="Mã sản phẩm VAT:"
                                    :disabled="
                                      !checkPermission('PRODUCT_VAT_UPSERT')
                                    "
                                  >
                                    <b-form-input
                                      size="sm"
                                      type="text"
                                      v-model="productCodeVat"
                                      placeholder="Nhập mã sản phẩm VAT"
                                    ></b-form-input>
                                  </b-form-group>

                                  <b-form-group
                                    label="Tên sản phẩm VAT:"
                                    :disabled="
                                      !checkPermission('PRODUCT_VAT_UPSERT')
                                    "
                                  >
                                    <b-form-input
                                      size="sm"
                                      v-model="productNameVat"
                                      placeholder="Nhập tên sản phẩm VAT"
                                    ></b-form-input>
                                  </b-form-group>

                                  <!-- <b-form-group label="Tên thương mại:">
                                    <b-form-input
                                      size="sm"
                                      v-model="productTradeName"
                                      placeholder="Nhập tên thương mại"
                                    ></b-form-input>
                                  </b-form-group>

                                  <b-form-group label="Mã hãng:">
                                    <b-form-input
                                      size="sm"
                                      v-model="productBrandCode"
                                      placeholder="Nhập mã hãng"
                                    ></b-form-input>
                                  </b-form-group> -->

                                  <!-- <b-form-group label="Alias:">
                                    <b-form-input
                                      size="sm"
                                      v-model="alias"
                                      placeholder="Nhập Alias"
                                    ></b-form-input>
                                  </b-form-group>

                                  <b-form-group label="Lưu ý sản phẩm:">
                                    <b-form-textarea
                                      size="sm"
                                      v-model="note"
                                      :placeholder="'Thêm lưu ý sản phẩm'"
                                      :rows="6"
                                      :max-rows="8"
                                      @change="genChildProduct"
                                    ></b-form-textarea>
                                  </b-form-group> -->

                                  <b-form-group label="Trạng thái:">
                                    <b-form-select
                                      v-model="selectedStatus"
                                      :options="listStatus"
                                      value-field="id"
                                      text-field="name"
                                      size="sm"
                                      @change="genChildProduct"
                                      class="select-style"
                                    >
                                      <template v-slot:first>
                                        <b-form-select-option
                                          :value="null"
                                          disabled
                                        >
                                          --Chọn trạng thái --
                                        </b-form-select-option>
                                      </template>
                                    </b-form-select>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <h4
                                    style="color='rgb(24, 28, 50)'"
                                    class="mb-6"
                                  >
                                    Thông tin giao dịch
                                  </h4>
                                  <b-form-group class="required-control">
                                    <label>Giá nhập</label>
                                    <b-form-input
                                      size="sm"
                                      v-model="importPrice"
                                      placeholder="Nhập giá nhập"
                                      class="text-right"
                                      v-mask="mask"
                                      @change="genChildProduct"
                                      :disabled="!isShowImportPrice"
                                    ></b-form-input>
                                  </b-form-group>

                                  <b-form-group label="Giá bán lẻ:">
                                    <b-form-input
                                      size="sm"
                                      v-model="salePrice"
                                      placeholder="Nhập giá bán"
                                      class="text-right"
                                      v-mask="mask"
                                      @change="genChildProduct"
                                    ></b-form-input>
                                  </b-form-group>

                                  <!--<b-form-group label="Giá bán buôn:">
                                    <b-form-input
                                      size="sm"
                                      v-model="wholesalePrice"
                                      placeholder="Nhập giá bán buôn"
                                      class="text-right"
                                      v-mask="mask"
                                      @change="genChildProduct"
                                    ></b-form-input>
                                  </b-form-group>

                                  <b-form-group class="required-control">
                                    <label> Giá niêm yết: </label>
                                    <b-form-input
                                      size="sm"
                                      v-model="$v.form.listedPrice.$model"
                                      placeholder="Nhập giá niêm yết"
                                      :state="validateState('listedPrice')"
                                      class="mt-1 text-right"
                                      @change="genChildProduct"
                                      v-mask="mask"
                                    ></b-form-input>
                                    <b-form-invalid-feedback
                                      >Số tiền phải lớn hơn
                                      0.</b-form-invalid-feedback
                                    >
                                  </b-form-group>

                                  <b-form-group label="Giá thu lại:">
                                    <b-form-input
                                      size="sm"
                                      v-model="returnSellingPrice"
                                      placeholder="Nhập giá thu lại"
                                      class="text-right"
                                      v-mask="mask"
                                      @change="genChildProduct"
                                    ></b-form-input>
                                  </b-form-group> -->
                                  <b-form-group class="required-control">
                                    <label class="d-block mt-1"> VAT: </label>
                                    <b-form-select
                                      class="select-style"
                                      size="sm"
                                      v-model="$v.form.productVat.$model"
                                      :state="validateState('productVat')"
                                      :options="listVat"
                                      value-field="id"
                                      text-field="label"
                                    >
                                    </b-form-select>
                                    <b-form-invalid-feedback>
                                      Yêu cầu nhập thuế suất. Thông tin liên hệ
                                      phòng kế toán.
                                    </b-form-invalid-feedback>
                                  </b-form-group>
                                  <b-form-group>
                                    <div>
                                      <label
                                        class="d-flex justify-content-between"
                                      >
                                        Đơn vị tính chuẫn:
                                        <span class="text-danger">*</span>
                                        <span
                                          @click="modelAddUom = !modelAddUom"
                                          class="d-inline-block ml-auto btn btn-primary pt-0 pb-0 pl-2 pr-2"
                                        >
                                          <i
                                            class="fas fa-plus icon-size-1-rem pr-0"
                                            v-b-tooltip.html.hover.top
                                            title="Thêm đơn vị tính"
                                          ></i>
                                          <!-- &nbsp; -->
                                        </span>
                                      </label>
                                    </div>

                                    <b-form-select
                                      class="select-style"
                                      size="sm"
                                      v-model="$v.form.unitId.$model"
                                      :options="unitOptions"
                                      value-field="id"
                                      text-field="label"
                                      :state="validateState('unitId')"
                                    >
                                    </b-form-select>
                                    <b-form-invalid-feedback
                                      >Yêu cầu chọn đơn vị
                                      tính.</b-form-invalid-feedback
                                    >
                                  </b-form-group>
                                  <b-form-group>
                                    <label class="d-block mt-1">
                                      Đơn vị chuyển đổi sang số lượng:
                                    </label>

                                    <treeselect
                                      :options="unitMultiOptions"
                                      v-model="unitMulti"
                                      :multiple="true"
                                      :normalizer="normalizer"
                                      :backspace-removes="false"
                                      placeholder="Chọn đơn vị chuyển đổi"
                                      :max-height="200"
                                      noResultsText="Không tìm thấy kết quả"
                                      valueFormat="object"
                                      :clearable="false"
                                      @select="showModelAddUnitMulti"
                                      @deselect="removeUOMMultiple"
                                    ></treeselect>
                                    <b-form-invalid-feedback
                                      >Yêu cầu chọn đơn vị
                                      tính.</b-form-invalid-feedback
                                    >
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <h4
                                    style="color='rgb(24, 28, 50)'"
                                    class="mb-5"
                                  >
                                    Thuộc tính
                                  </h4>
                                  <b-form-group label="Loại sản phẩm:">
                                    <b-form-select
                                      size="sm"
                                      v-model="selectedType"
                                      :options="listType"
                                      value-field="id"
                                      text-field="label"
                                      @change="onSelectType"
                                      class="select-style"
                                      disabled
                                    >
                                      <template v-slot:first>
                                        <b-form-select-option
                                          :value="null"
                                          disabled
                                          >Chọn loại sản
                                          phẩm</b-form-select-option
                                        >
                                      </template>
                                    </b-form-select>
                                  </b-form-group>

                                  <!-- <b-form-group label="Xuất xứ:">
                                    <b-input-group>
                                      <b-form-select
                                        size="sm"
                                        v-model="selectedOriginal"
                                        :options="listOrginal"
                                        value-field="id"
                                        text-field="name"
                                        class="select-style"
                                      >
                                        <template v-slot:first>
                                          <b-form-select-option
                                            :value="null"
                                            disabled
                                            >Chọn xuất xứ</b-form-select-option
                                          >
                                        </template>
                                      </b-form-select>
                                    </b-input-group>
                                  </b-form-group> -->

                                  <b-form-group>
                                    <label
                                      class="d-flex justify-content-between"
                                    >
                                      Thương hiệu:
                                      <span class="text-danger">*</span>
                                      <span
                                        @click="
                                          showBrandModel = !showBrandModel
                                        "
                                        class="d-inline-block ml-auto btn btn-primary pt-0 pb-0 pl-2 pr-2"
                                      >
                                        <i
                                          class="fas fa-plus icon-size-1-rem pr-0"
                                          v-b-tooltip.html.hover.top
                                          title="Thêm đơn vị tính"
                                        ></i>
                                      </span>
                                    </label>
                                    <Autosuggest
                                      :model="$v.form.searchBrandName.$model"
                                      :suggestions="filteredBrandOptions"
                                      :placeholder="'thương hiệu'"
                                      :limit="200"
                                      @select="onSelectedBrand"
                                      @change="onInputBrandChange"
                                      :state="validateState('searchBrandName')"
                                      errorMessages="Yêu cầu chọn thương hiệu."
                                    />
                                  </b-form-group>

                                  <b-form-group label="Phiên bản xe">
                                    <b-form-input
                                      size="sm"
                                      v-model="version"
                                      placeholder="Nhập phiên bản"
                                    ></b-form-input>
                                  </b-form-group>

                                  <b-form-group label="Màu sắc xe">
                                    <b-form-input
                                      size="sm"
                                      v-model="colorExterior"
                                      placeholder="Nhập màu sắc"
                                    ></b-form-input>
                                  </b-form-group>

                                  <b-form-group label="Màu sắc nội thất">
                                    <b-form-input
                                      size="sm"
                                      v-model="colorInterior"
                                      placeholder="Nhập màu sắc"
                                    ></b-form-input>
                                  </b-form-group>
                                </b-col>
                              </b-row>

                              <div
                                v-if="
                                  !parentId &&
                                  selectedType !==
                                    PRODUCT_TYPE_ENUM['SERVICE'] &&
                                  selectedType !==
                                    PRODUCT_TYPE_ENUM['INDEPENDENT']
                                "
                                class="separator separator-dashed my-5"
                              ></div>

                              <div
                                v-if="
                                  !parentId &&
                                  selectedType !==
                                    PRODUCT_TYPE_ENUM['SERVICE'] &&
                                  selectedType !==
                                    PRODUCT_TYPE_ENUM['INDEPENDENT']
                                "
                              >
                                <b-row>
                                  <b-col>
                                    <h4>Sản phẩm con</h4>
                                  </b-col>
                                  <b-col>
                                    <div
                                      class="justify-content-end"
                                      style="text-align: end"
                                    >
                                      <div class="mb-5">
                                        <b-button
                                          class="btn btn-primary font-weight-bolder btn-sm button"
                                          variant="primary"
                                          @click="showModalAddProduct"
                                        >
                                          <i
                                            style="font-size: 1rem"
                                            class="flaticon2-add-1"
                                          ></i
                                          >Thêm mới
                                        </b-button>
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-table
                                  v-if="childrens.length"
                                  :items="childrens"
                                  :fields="fields"
                                  class="table-bordered table-hover col-md-12"
                                >
                                  <template v-slot:cell(count)="row">
                                    <div class="text-center">
                                      {{ row.item.count }}
                                    </div>
                                  </template>
                                  <template v-slot:cell(deleted)="row">
                                    <div class="text-center">
                                      <span
                                        v-text="
                                          checkStatusDeleted(row.item.deleted)
                                        "
                                        class="label font-weight-bold label-lg label-inline"
                                        v-bind:class="{
                                          'label-light-success':
                                            row.item.deleted === 0,
                                          'label-light-danger':
                                            row.item.deleted === 1,
                                        }"
                                        style="width: max-content"
                                      ></span>
                                    </div>
                                  </template>
                                  <template v-slot:cell(importPrice)="row">
                                    <div style="text-align: end">
                                      <span
                                        v-text="
                                          convertPrice(row.item.importPrice)
                                        "
                                      ></span>
                                    </div>
                                  </template>
                                  <template v-slot:cell(sellingPrice)="row">
                                    <div style="text-align: end">
                                      <span
                                        v-text="
                                          convertPrice(row.item.sellingPrice)
                                        "
                                      ></span>
                                    </div>
                                  </template>
                                </b-table>
                              </div>
                            </div>
                          </div>
                          <!--end: Thông tin chung-->

                          <!--begin:Bảo hành & vận chuyển-->
                          <!-- <div
                            class="pb-5 full-width"
                            data-wizard-type="step-content"
                          >
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-md-3">
                                  <p class="mt-4 label-header-form">
                                    <strong>Kích thước</strong>
                                  </p>
                                  <b-form-group
                                    label="Khối lượng:"
                                    style="padding: 0px"
                                  >
                                    <b-form-input
                                      size="sm"
                                      v-model="weight"
                                      placeholder="Nhập khối lượng"
                                      type="number"
                                      class="text-right"
                                    ></b-form-input>
                                  </b-form-group>

                                  <b-form-group
                                    label="Chiều dài:"
                                    style="padding: 0px"
                                  >
                                    <b-form-input
                                      size="sm"
                                      v-model="length"
                                      placeholder="Nhập chiều dài"
                                      type="number"
                                      class="text-right"
                                    ></b-form-input>
                                  </b-form-group>

                                  <b-form-group
                                    label="Chiều rộng:"
                                    style="padding: 0px"
                                  >
                                    <b-form-input
                                      size="sm"
                                      v-model="width"
                                      placeholder="Nhập chiều rộng sản phẩm"
                                      type="number"
                                      class="text-right"
                                    ></b-form-input>
                                  </b-form-group>

                                  <b-form-group
                                    label="Chiều cao:"
                                    style="padding: 0px"
                                  >
                                    <b-form-input
                                      size="sm"
                                      v-model="height"
                                      placeholder="Nhập chiều cao sản phẩm"
                                      type="number"
                                      class="text-right"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-md-3">
                                  <p class="mt-4 label-header-form">
                                    <strong>Bảo hành</strong>
                                  </p>
                                  <b-form-group
                                    label="Địa chỉ bảo hành:"
                                    style="padding: 0px"
                                  >
                                    <b-form-input
                                      size="sm"
                                      v-model="warrantyAddress"
                                      placeholder="Nhập địa chỉ bảo hành"
                                    ></b-form-input>
                                  </b-form-group>

                                  <b-form-group
                                    label="Số điện thoại:"
                                    style="padding: 0px"
                                  >
                                    <b-form-input
                                      size="sm"
                                      type="text"
                                      v-model="warrantyPhone"
                                      placeholder="Nhập số điện thoại"
                                    ></b-form-input>
                                  </b-form-group>
                                  <b-form-group
                                    label="Số tháng bảo hành:"
                                    style="padding: 0px"
                                  >
                                    <b-form-input
                                      size="sm"
                                      type="number"
                                      v-model="warrantyMonthNo"
                                      placeholder="Nhập số tháng bảo hành"
                                      class="text-right"
                                    ></b-form-input>
                                  </b-form-group>
                                  <b-form-group label="Nội dung:">
                                    <b-form-textarea
                                      size="sm"
                                      v-model="warrantyDescription"
                                      :placeholder="'Thêm nội dung'"
                                      :rows="6"
                                      :max-rows="8"
                                    ></b-form-textarea>
                                  </b-form-group>
                                </div>
                              </div>
                            </div>
                          </div> -->
                          <!--end:Bảo hành & vận chuyển-->

                          <!--start:Lịch sử-->
                          <!-- <div
                            class="pb-5 full-width"
                            data-wizard-type="step-content"
                          >
                            <b-container class="bv-example-row">
                              <b-table
                                :fields="historyFields"
                                :items="histories"
                                class="table-bordered table-hover col-md-6"
                              >
                                <template v-slot:cell(createdBy)="row">
                                  <p>{{ row.item.createdBy }}</p>
                                  <p>{{ row.item.createdAt }}</p>
                                </template>

                                <template v-slot:cell(detail)="row">
                                  <div
                                    class="orderCode"
                                    @click="viewHistoryDetail(row.item.id)"
                                    style="cursor: pointer; color: #3699ff"
                                  >
                                    <span v-text="'Chi tiết'"></span>
                                  </div>
                                </template>
                              </b-table>
                            </b-container>
                          </div> -->
                          <!--end:Lịch sử-->
                        </form>
                        <!--end: Wizard Form-->
                      </div>
                    </div>
                  </div>
                </div>
                <!--end: Wizard Bpdy-->
              </div>
              <!--end: Wizard-->

              <b-modal
                ref="add-product-modal"
                hide-footer
                title="Thêm mới sản phẩm con"
                v-model="showAddProduct"
                id="modal-prevent-closing"
              >
                <v-form ref="form" lazy-validation>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <b-form-group label="Mã sản phẩm:" style="padding: 0px">
                          <b-form-input
                            size="sm"
                            type="text"
                            v-model="childCode"
                            placeholder="Nhập mã vạch sản phẩm"
                          ></b-form-input>
                          <b-form-invalid-feedback id="input-live-feedback"
                            >Nhập ít nhất 1 ký tự</b-form-invalid-feedback
                          >
                        </b-form-group>
                        <p class="mt-4 mb-4">
                          <strong>Thuộc tính</strong>
                        </p>
                        <b-form-group class="required-control">
                          <label> Màu sắc: </label>
                          <b-form-input
                            size="sm"
                            v-model="colorChildExterior"
                            placeholder="Nhập màu sắc"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group
                          label="Màu sắc nội thất:"
                          v-if="
                            selectedType === PRODUCT_TYPE_ENUM['CHASSIS_ENGINE']
                          "
                        >
                          <b-form-input
                            size="sm"
                            v-model="colorChildInterior"
                            placeholder="Nhập màu sắc"
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group
                          class="required-control"
                          v-if="
                            selectedType === PRODUCT_TYPE_ENUM['CHASSIS_ENGINE']
                          "
                        >
                          <label> Phiên bản xe: </label>
                          <b-form-input
                            size="sm"
                            v-model="childVersion"
                            placeholder="Nhập phiên bản xe"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <p class="mt-25 mb-4">
                          <strong>Thông tin giao dịch</strong>
                        </p>
                        <b-form-group label="Giá nhập:">
                          <b-form-input
                            size="sm"
                            v-model="importChildPrice"
                            placeholder="Nhập giá nhập"
                            class="text-right"
                            v-mask="mask"
                            disabled
                          ></b-form-input>
                          <b-form-invalid-feedback id="input-live-feedback"
                            >Nhập ít nhất 1 ký tự</b-form-invalid-feedback
                          >
                        </b-form-group>

                        <b-form-group label="Giá bán:" style="padding: 0px">
                          <b-form-input
                            size="sm"
                            v-model="sellingChildPrice"
                            required
                            placeholder="Nhập giá bán"
                            type="text"
                            class="text-right"
                            v-mask="mask"
                          ></b-form-input>
                          <b-form-invalid-feedback id="input-live-feedback"
                            >Nhập ít nhất 1 ký tự</b-form-invalid-feedback
                          >
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <b-button
                    style="fontweight: 600; width: 70px"
                    variant="primary"
                    size="sm"
                    @click="createChildProduct"
                    >Lưu</b-button
                  >
                  <b-button
                    style="margin-left: 10px; font-weight: 600; width: 70px"
                    variant="secondary"
                    size="sm"
                    @click="hideModalAddProduct"
                    >Hủy</b-button
                  >
                </v-form>
              </b-modal>

              <b-modal
                v-model="showBrandModel"
                hide-footer
                title="Thêm mới thương hiệu"
              >
                <b-row class="mb-5">
                  <b-col>
                    <label class="labelInput">Tên thương hiệu:</label>
                    <b-form-input
                      size="sm"
                      v-model="brandName"
                      placeholder="Nhập tên thương hiệu"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button
                      style="fontweight: 600; width: 70px"
                      variant="primary"
                      size="sm"
                      @click="createBrand()"
                      >Lưu</b-button
                    >
                    <b-button
                      @click="showBrandModel = !showBrandModel"
                      style="margin-left: 10px; font-weight: 600; width: 70px"
                      variant="secondary"
                      size="sm"
                      >Hủy</b-button
                    >
                  </b-col>
                </b-row>
              </b-modal>

              <b-modal
                v-model="modelAddUnitMulti"
                hide-footer
                title="Thêm đơn vị chuyển đổi"
                @hide="hideModalAddUnitMulti"
              >
                <b-row class="mb-5">
                  <b-col>
                    <label class="labelInput">Tỉ lệ chuyển đổi:</label>
                    <b-form-input
                      size="sm"
                      v-model="conversionRateUnit"
                      placeholder="Nhập tỉ lệ chuyển đổi"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button
                      style="fontweight: 600; width: 70px"
                      variant="primary"
                      size="sm"
                      @click="createUnitMulti()"
                      >Lưu</b-button
                    >
                    <b-button
                      @click="hideModalAddUnitMulti"
                      style="margin-left: 10px; font-weight: 600; width: 70px"
                      variant="secondary"
                      size="sm"
                      >Hủy</b-button
                    >
                  </b-col>
                </b-row>
              </b-modal>

              <b-modal
                v-model="modelAddUom"
                hide-footer
                title="Thêm đơn vị tính"
              >
                <b-row class="mb-5">
                  <b-col>
                    <label class="labelInput">Tên đơn vị tính:</label>
                    <b-form-input
                      size="sm"
                      v-model="nameUom"
                      placeholder="Nhập tên đơn vị tính"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button
                      style="fontweight: 600; width: 70px"
                      variant="primary"
                      size="sm"
                      @click="createUom()"
                      >Lưu</b-button
                    >
                    <b-button
                      @click="modelAddUom = false"
                      style="margin-left: 10px; font-weight: 600; width: 70px"
                      variant="secondary"
                      size="sm"
                      >Hủy</b-button
                    >
                  </b-col>
                </b-row>
              </b-modal>
            </div>
          </b-card>
        </v-form>
      </template>
      <template v-slot:foot>
        <b-button
          style="fontweight: 600; width: 70px"
          variant="primary"
          size="sm"
          @click="onClickToUpdate"
          >Lưu</b-button
        >
        <router-link to="/products" tag="button">
          <b-button
            style="margin-left: 10px; font-weight: 600; width: 70px"
            variant="secondary"
            size="sm"
            >Hủy</b-button
          >
        </router-link>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import debounce from 'debounce';
import { keyBy } from 'lodash';
import { v4 } from 'uuid';
import Swal from 'sweetalert2';
// import VueMultiSelect from 'vue-simple-multi-select';
import { validationMixin } from 'vuelidate';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import localData from '@/utils/saveDataToLocal';
import KTCodePreview from '@/view/content/CodeTab.vue';
import KTUtil from '@/assets/js/components/util';
import KTWizard from '@/assets/js/components/wizard';
import {
  convertPrice,
  currencyMask,
  genMultilineRegexp,
  makeToastFaile,
  makeToastSuccess,
  removeAccents,
  unMaskPrice,
} from '@/utils/common';
import { TIME_TRIGGER } from '@/utils/constants';
import { PRODUCT_STATUS, PRODUCT_TYPE, PRODUCT_TYPE_ENUM } from '@/utils/enum';
import { showConfirmNotify } from '@/utils/sweet-alert2';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { cloneDeep } from '../../../utils/common';

// const checkCurrency = (value) => {
//   const money = unMaskPrice(value);
//   const moneyDec = toNumber(money);
//   return moneyDec > 0;
// };

const hasSpecialCharacters = (string) => {
  const regexSpecialCharacters = /[\s~`!@#$%^&*+=[\]\\';,/{}|\\":<>?()._]/g;
  const normalizedString = string.normalize().trim();
  return !regexSpecialCharacters.test(normalizedString);
};

const checkAscent = (string) => {
  const regexAscent = genMultilineRegexp(
    [
      'à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ|',
      'è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ|',
      'ì|í|ị|ỉ|ĩ|',
      'ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ|',
      'ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ|',
      'ỳ|ý|ỵ|ỷ|ỹ|',
      'đ',
    ],
    'g',
  );
  return !regexAscent.test(string);
};

const removeVietnameseCharactor = (str) => {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  str = str.replace(/Đ/g, 'D');
  return str;
};

export default {
  mixins: [validationMixin],
  validations: {
    form: {
      code: {
        required,
        maxLength: maxLength(50),
        minLength: minLength(3),
        hasSpecialCharacters,
        checkAscent,
      },
      name: {
        required,
      },
      selectedCate: {
        required,
      },
      searchBrandName: {
        required,
      },
      unitId: {
        required,
      },
      productVat: {
        required,
      },
    },
  },
  data() {
    return {
      PRODUCT_TYPE_ENUM: PRODUCT_TYPE_ENUM,
      idSync: null,
      childVersion: null,
      colorChildInterior: null,
      colorChildExterior: null,
      sellingChildPrice: 0,
      importChildPrice: 0,
      childCode: null,
      showAddProduct: false,
      productChild: [],
      parentId: null,
      childrens: [],
      nameUom: null,
      modelAddUom: false,
      unitMultiOptions: [],
      conversionRateUnit: null,
      version: null,
      colorInterior: null,
      colorExterior: null,
      listUom: [],
      listVat: [],
      unitMulti: [],
      selectedUnitMulti: null,
      modelAddUnitMulti: false,

      productType: PRODUCT_TYPE,
      productStatus: PRODUCT_STATUS,
      isEditedProductCode: false,
      form: {
        name: '',
        code: '',
        category: '',
        listedPrice: 0,
        selectedCate: '',
        selectedExternalCate: '',
        searchBrandName: '',
        unitId: null,
        productVat: null,
        unitMultiIds: [],
      },
      productCodeVat: '',
      productNameVat: '',
      productTradeName: '',
      productBrandCode: '',
      alias: '',
      productVat: null,
      returnSellingPrice: 0,
      productPropertyId: '',
      colorName: '',
      statusName: '',
      brandName: '',
      providerName: '',
      showOriginalModel: false,
      showBrandModel: false,
      showColorModel: false,
      showStatusModel: false,
      mask: currencyMask,
      fields: [
        {
          key: 'count',
          label: 'STT',
          sortable: false,
          thStyle: { textAlign: 'center', width: '5%' },
        },
        {
          key: 'code',
          label: 'Mã sản phẩm',
          sortable: false,
          thStyle: { textAlign: 'center', width: '25%' },
        },
        {
          key: 'name',
          label: 'Tên sản phẩm',
          sortable: false,
          thStyle: { textAlign: 'center', width: '35%' },
        },
        {
          key: 'importPrice',
          label: 'Giá nhập',
          sortable: false,
          thStyle: { textAlign: 'center', width: '10%' },
        },
        {
          key: 'sellingPrice',
          label: 'Giá bán',
          sortable: false,
          thStyle: { textAlign: 'center', width: '10%' },
        },
        {
          key: 'deleted',
          label: 'Trạng thái',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          tdClass: 'statusProClass',
          thClass: 'statusProClass',
        },
      ],

      barcode: '',
      importPrice: 0,
      salePrice: 0,
      warrantyAddress: '',
      warrantyPhone: '',
      warrantyMonthNo: 0,
      warrantyDescription: '',
      width: 0,
      height: 0,
      length: 0,
      weight: 0,
      selectedParent: '',
      listColor: [],
      selectedColor: null,
      listSize: [],
      selectedSize: null,
      selectedType: null,
      listType: [],
      selectedOriginal: null,
      listOrginal: [],
      selectedBrand: null,
      listBrand: [],
      childName: '',
      childId: 0,
      childBarCode: '',
      childOriginalPrice: 0,
      childSalePrice: 0,
      productComboPrice: '',
      productComboRate: '',
      selectedColorChild: null,
      selectedSizeChild: null,
      selectedProduct: '',
      proComboQuantity: 1,
      listProductInCombo: [],
      showCombo: false,
      selectProductComboId: 0,
      productId: '',
      selectedProductId: '',
      selectedStatus: null,
      // listStatus: [
      //   { id: 1, name: 'Mới' },
      //   { id: 2, name: 'Đang bán' },
      //   { id: 3, name: 'Ngừng bán' },
      //   { id: 4, name: 'Hết hàng' },
      // ],
      listStatus: [
        { id: 0, name: 'Bật' },
        { id: 1, name: 'Tắt' },
      ],
      selectedColorOriginal: null,
      selectedSizeOriginal: null,
      options: [
        {
          data: [],
        },
      ],
      cateOptions: [],
      filteredOptions: [],
      filteredCateOptions: [],
      selectedClassParent: null,
      externalCateOptions: [],
      filteredExternalCateOptions: [],
      selectedExternalCateId: null,
      selectedCateId: null,
      selectedProductForCombo: {
        id: null,
        code: '',
        name: '',
        quantity: 0,
      },
      searchProductForCombo: '',
      wholesalePrice: 0,

      colorCode: '',
      statusCode: '',
      isSearching: false,
      historyFields: [
        {
          key: 'createdBy',
          label: 'Người tạo',
          thStyle: { textAlign: 'center' },
          tdClass: 'textleft',
        },
        {
          key: 'actionName',
          label: 'Hành động',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          tdClass: 'text-left',
        },
        {
          key: 'detail',
          label: 'Chi tiết',
          sortable: false,
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          tdClass: 'text-left',
        },
      ],
      histories: [],
      history: {
        createdBy: '',
        createdAt: '',
        diffValues: [],
      },
      historyDetailFields: [
        {
          key: 'keyName',
          label: 'Thông tin',
          thStyle: { textAlign: 'center', width: '20%' },
          tdClass: 'text-left',
        },
        {
          key: 'originalValue',
          label: 'Trước',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '40%',
          },
        },
        {
          key: 'newValue',
          label: 'Sau',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '40%',
          },
        },
      ],
      note: '',
      listProductNew: [],
      fieldProductNew: [
        {
          key: 'productCode',
          label: 'Mã sản phẩm',
          sortable: false,
          thStyle: { textAlign: 'center', width: '25%' },
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
          sortable: false,
          thStyle: { textAlign: 'center', width: '40%' },
        },
        {
          key: 'originalPrice',
          label: 'Giá nhập',
          sortable: false,
          thStyle: { textAlign: 'center', width: '15%' },
        },
        {
          key: 'sellingPrice',
          label: 'Giá bán',
          sortable: false,
          thStyle: { textAlign: 'center', width: '15%' },
        },
        {
          key: 'actions',
          label: '',
          sortable: false,
          thStyle: { textAlign: 'center', width: '5%' },
        },
      ],
      isGenChild: false,
      listColorNew: [],
      listSizeNew: [],
      brandOptions: [],
      filteredBrandOptions: [],
      unitOptions: [],
      isShowImportPrice: false,
      originalPrice: 0,
    };
  },
  components: {
    KTCodePreview,
    // VueMultiSelect,
    Autosuggest,
    Treeselect,
  },
  computed: {
    productIdFromUrl() {
      return this.$route.query.id || null;
    },
  },
  async created() {
    await this.getInitData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Sản phẩm', route: '/products' },
      { title: 'Danh sách sản phẩm', route: '/products' },
      { title: 'Cập nhật sản phẩm' },
    ]);

    const wizard = new KTWizard('kt_wizard_v4', {
      startStep: 1,
      clickableSteps: true,
    });

    wizard.on('beforeNext', function (/*wizardObj*/) {});

    wizard.on('change', function (/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  methods: {
    convertPrice,
    makeToastFaile,
    makeToastSuccess,
    showConfirmNotify,
    normalizerCate(node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      };
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.label,
      };
    },
    checkStatusDeleted: function (item) {
      switch (item) {
        case 0:
          return 'Bật';
        case 1:
          return 'Tắt';
      }
    },
    createBrand() {
      if (!this.brandName) {
        this.makeToastFaile('Vui lòng nhập tên đơn vị tính!');
        return;
      }
      const body = {
        name: this.brandName,
      };

      ApiService.post('/product-brands/', body)
        .then(({ data }) => {
          const response = data.data;

          this.showBrandModel = false;
          this.brandName = null;
          this.filteredBrandOptions.push({
            id: response.id,
            label: response.name,
          });
          // todo
          this.makeToastSuccess('Tạo thương hiệu thành công');
        })
        .catch((error) => {
          this.makeToastFaile(error);
        });
    },
    createUnitMulti() {
      if (!this.productIdFromUrl) {
        this.makeToastFaile('ID sản phẩm không tồn tại!');
        return;
      }
      if (
        this.selectedUnitMulti &&
        !Object.keys(this.selectedUnitMulti).length
      ) {
        this.makeToastFaile('Vui lòng chọn đơn vị chuyển đổi!');
        return;
      }
      if (!this.conversionRateUnit) {
        this.makeToastFaile('Vui lòng nhập giá trị chuyển đổi!');
        return;
      }
      const data = {
        productId: this.productIdFromUrl,
        uomId: this.selectedUnitMulti.id,
        conversionRate: this.conversionRateUnit,
        primaryUom: false,
      };
      ApiService.post('/product-uom-multiples', data)
        .then(({ data }) => {
          const _unitMulti = cloneDeep(this.unitMulti);
          const object = keyBy(_unitMulti, 'id');
          console.log(data, object);

          // if(object[])
          // this.unitMulti = _unitMulti.map((item) => {
          //   if (
          //     this.selectedUnitMulti &&
          //     this.selectedUnitMulti.id === data.data.uomId
          //   ) {
          //     item['label'] = `${item.label} - ${data.data.conversionRate}`;
          //   }
          //   return item;
          // });

          // if (this.unitMultiOptions.length) {
          //   const object = keyBy(this.unitMulti, 'id');

          //   this.unitMultiOptions = this.unitMultiOptions.map((item) => {
          //     if (object[item['id']]) {
          //       item['label'] = object[item['id']]['label'];
          //     }
          //     return item;
          //   });
          // }

          this.selectedUnitMulti = null;
          this.modelAddUnitMulti = false;
          this.conversionRateUnit = null;
          this.makeToastSuccess('Tạo đơn vị chuyển đổi thành công');
        })
        .catch(({ response }) => {
          this.makeToastFaile(
            response.data.message || 'Lỗi hệ thống vui lòng thử lại sau!!',
          );
        });
    },
    createUom() {
      if (!this.nameUom) {
        this.makeToastFaile('Vui lòng nhập tên đơn vị tính!');
        return;
      }
      const body = {
        name: this.nameUom,
      };

      ApiService.post('/product-uoms/', body)
        .then(({ data }) => {
          const response = data.data;
          this.unitOptions.push({
            id: response.id,
            label: response.name,
          });
          this.modelAddUom = false;
          this.nameUom = null;
          this.makeToastSuccess('Tạo đơn vị tính thành công');
        })
        .catch((error) => {
          this.makeToastFaile(error);
        });
    },
    showModelAddUnitMulti(options) {
      this.modelAddUnitMulti = !this.modelAddUnitMulti;
      this.selectedUnitMulti = options;
    },
    removeUOMMultiple(removeValue) {
      console.log(removeValue);
      Swal.fire({
        title: 'Xóa đơn vị chuyển đổi!',
        text: 'Bạn có chắc muốn xóa đơn vị chuyển đổi này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        position: 'center',
      }).then((result) => {
        if (result.value) {
          this.handleRemoveUOMMultiple(removeValue);
        }
      });
    },
    handleRemoveUOMMultiple(data) {
      const body = {
        id: data.uomMultiId,
        deleted: 1,
      };
      ApiService.put('product-uom-multiples', body)
        .then(() => {
          this.getProductById();
          this.makeToastSuccess('Xóa UOM Thành công!');
        })
        .catch(() => {
          this.makeToastFaile('Lỗi');
        });
    },
    hideModalAddUnitMulti() {
      this.modelAddUnitMulti = false;
      this.unitMulti = this.unitMulti.filter(
        (item) => item.id !== this.selectedUnitMulti.id,
      );
      this.selectedUnitMulti = null;
    },

    async getInitData() {
      try {
        this.selectedProduct = '';
        await Promise.all([
          this.getListCate(),
          this.getListVat(),
          this.getListUom(),
          this.getListType(),
          // this.getListExternalCate(),
          this.fetchBrand(),
          // this.fetchProvider(),
          // this.getColorProperty(),
          // this.getSizeProperty(),
          // this.getHistoryByProductId(),
        ]);
        await this.getProductById();
      } catch (error) {
        this.makeToastFaile(error);
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    // getListCate: function () {
    //   const param = {
    //     page: 1,
    //     limit: 10,
    //     name: '',
    //     code: '',
    //   };
    //   const paramQuery = {
    //     params: param,
    //   };
    //   ApiService.query('category', paramQuery).then(({ data }) => {
    //     this.numberOfPage = data.data.total_page;
    //     data.data.list_caterogy.forEach((element) => {
    //       let name = '';
    //       if (element.level === 1) {
    //         name = '-' + element.name;
    //       } else if (element.level === 2) {
    //         name = '--' + element.name;
    //       } else if (element.level === 3) {
    //         name = '---' + element.name;
    //       } else if (element.level === 4) {
    //         name = '----' + element.name;
    //       } else if (element.level === 5) {
    //         name = '-----' + element.name;
    //       } else if (element.level === 6) {
    //         name = '------' + element.name;
    //       } else {
    //         name = element.name;
    //       }
    //       let item = {
    //         id: element.id,
    //         name: element.name,
    //         suggestionName: name,
    //       };
    //       this.cateOptions.push(item);
    //     });

    //     this.filteredCateOptions = [...this.cateOptions];
    //   });
    // },
    getListCate() {
      const param = {
        page: 1,
        limit: 9999999999,
        search: '',
      };
      const paramQuery = {
        params: param,
      };
      ApiService.query('category', paramQuery).then(({ data }) => {
        const dataCate = data.data;
        this.numberOfPage = dataCate.paginations.total;
        dataCate.data.forEach((element) => {
          let item = {
            id: element.id,
            name: element.name,
            suggestionName: element.name,
            children: element.children,
          };
          this.cateOptions.push(item);
        });

        this.filteredCateOptions = [...this.cateOptions];
      });
    },
    getListVat() {
      const param = {
        page: 1,
        limit: 9999999999,
        search: '',
      };
      const paramQuery = {
        params: param,
      };
      ApiService.query('product-vat', paramQuery).then(({ data }) => {
        this.listVat = [...data.data];
      });
    },
    getListUom() {
      const param = {
        page: 1,
        limit: 9999999999,
        search: '',
      };
      const paramQuery = {
        params: param,
      };
      ApiService.get(`product-uoms`, paramQuery)
        .then(({ data }) => {
          const dataUom = data.data;
          for (const item of dataUom.data) {
            const dataPush = {
              id: item.id,
              label: item.name,
              name: item.name,
            };
            this.unitOptions.push(dataPush);
            // this.unitMultiOptions.push(dataPush);
          }
          // this.unitMultiOptions = cloneDeep(this.unitOptions);
        })
        .catch(() => {
          this.makeToastFaile('Lỗi');
        });
    },
    getListType() {
      const param = {
        page: 1,
        limit: 9999999999,
        search: '',
      };
      const paramQuery = {
        params: param,
      };
      ApiService.get(`products/type`, paramQuery)
        .then(({ data }) => {
          const response = data.data;
          this.listType = response;
        })
        .catch(() => {
          this.makeToastFaile('Lỗi');
        });
    },
    fetchBrand: function () {
      this.listBrand = [];
      const param = {
        page: 1,
        pageSize: 1000000,
        search: '',
      };
      const paramQuery = {
        params: {
          param,
        },
      };
      ApiService.query('product-brands', paramQuery).then(({ data }) => {
        data.data.data.forEach((item) => {
          const brand = {
            id: item.id,
            name: item.name,
          };
          this.listBrand.push(brand);
        });

        this.brandOptions = data.data.data;
        this.filteredBrandOptions = [...this.brandOptions];
      });
    },
    fetchProvider: function () {
      this.listOrginal = [];
      ApiService.get('city/country').then((response) => {
        response.data.data.forEach((item) => {
          let provider = {
            id: item.id,
            name: item.name,
          };
          this.listOrginal.push(provider);
        });
      });
    },
    getColorProperty: function () {
      ApiService.get(`property/getByType/1`)
        .then(({ data }) => {
          if (data.status === 1) {
            this.listColor = data.data;
          } else {
            this.makeToastFaile('Tải dữ liệu thất bại!');
          }
        })
        .catch(({ response }) => {
          this.makeToastFaile(response.$error);
        });
    },
    getSizeProperty: function () {
      ApiService.get(`property/getByType/2`)
        .then(({ data }) => {
          if (data.status === 1) {
            this.listSize = data.data;
          } else {
            this.makeToastFaile('Tải dữ liệu thất bại!');
          }
        })
        .catch(({ response }) => {
          this.makeToastFaile(response.$error);
        });
    },
    genChildProduct() {
      this.listProductNew = [];
      if (!this.isGenChild || this.selectedParent || this.selectedType === 3) {
        this.listProductNew = [];
        return;
      }
      if (this.listColorNew.length === 0 && this.listSizeNew.length) {
        for (let i = 0; i < this.listSizeNew.length; i++) {
          const size = this.listSizeNew[i];
          const product = {
            id: v4(),
            productName: this.$v.form.name.$model + ' - ' + size.name,
            productCode: this.$v.form.code.$model + '-' + size.code,
            parentProductId: this.productIdFromUrl,
            barCode: '',
            brand: this.selectedBrand,
            originalPrice: unMaskPrice(this.importPrice),
            sellingPrice: unMaskPrice(this.salePrice),
            wholesalePrice: this.wholesalePrice
              ? unMaskPrice(this.wholesalePrice)
              : 0,
            listedPrice: this.$v.form.listedPrice.$model
              ? unMaskPrice(this.$v.form.listedPrice.$model)
              : 0,
            color: null,
            unitId: this.$v.form.unitId.$model,
            productVat: this.$v.form.productVat.$model,
            size: size.id,
            isNew: true,
            note: this.note,
          };
          this.listProductNew.push(product);
        }
      } else if (this.listColorNew.length && this.listSizeNew.length === 0) {
        for (let i = 0; i < this.listColorNew.length; i++) {
          const color = this.listColorNew[i];
          const product = {
            id: v4(),
            productName: this.$v.form.name.$model + ' - ' + color.name,
            productCode: this.$v.form.code.$model + '-' + color.code,
            parentProductId: this.productIdFromUrl,
            barCode: '',
            original: this.selectedOriginal,
            brand: this.selectedBrand,
            originalPrice: unMaskPrice(this.importPrice),
            unitId: this.$v.form.unitId.$model,
            productVat: this.$v.form.productVat.$model,
            sellingPrice: unMaskPrice(this.salePrice),
            wholesalePrice: this.wholesalePrice
              ? unMaskPrice(this.wholesalePrice)
              : 0,
            listedPrice: this.$v.form.listedPrice.$model
              ? unMaskPrice(this.$v.form.listedPrice.$model)
              : 0,
            color: color.id,
            size: null,
            isNew: true,
          };
          this.listProductNew.push(product);
        }
      } else {
        for (let index = 0; index < this.listColorNew.length; index++) {
          const color = this.listColorNew[index];
          for (let i = 0; i < this.listSizeNew.length; i++) {
            const size = this.listSizeNew[i];
            const product = {
              id: v4(),
              productName:
                this.$v.form.name.$model +
                ' - ' +
                color.name +
                ' - ' +
                size.name,
              productCode:
                this.$v.form.code.$model + '-' + color.code + '-' + size.code,
              parentProductId: this.productIdFromUrl,
              barCode: '',
              originalPrice: unMaskPrice(this.importPrice),
              sellingPrice: unMaskPrice(this.salePrice),
              unitId: this.$v.form.unitId.$model,
              productVat: this.$v.form.productVat.$model,
              wholesalePrice: this.wholesalePrice
                ? unMaskPrice(this.wholesalePrice)
                : 0,
              listedPrice: this.$v.form.listedPrice.$model
                ? unMaskPrice(this.$v.form.listedPrice.$model)
                : 0,
              color: color.id,
              size: size.id,
              isNew: true,
            };
            this.listProductNew.push(product);
          }
        }
      }
    },

    checkPermission(condition) {
      return localData.checkPermission(condition);
    },
    showModalAddProduct() {
      this.$refs['add-product-modal'].show();
    },
    hideModalAddProduct() {
      this.$refs['add-product-modal'].hide();
    },
    showModalUpdateProduct() {
      this.selectedParent = null;
      this.$refs['update-product-modal'].show();
    },
    hideModalUpdateProduct() {
      this.$refs['update-product-modal'].hide();
    },
    editItem(item) {
      this.childId = item.id;
      this.childCode = item.productCode;
      this.childName = item.productName;
      this.childBarCode = item.barCode;
      this.childOriginalPrice = item.originalPrice;
      this.childSalePrice = item.sellingPrice;
      this.showModalUpdateProduct();
    },
    updateItem(index, item) {
      const data = {
        ...item,
        productComboPrice: unMaskPrice(item.productComboPrice),
      };

      this.listProductInCombo[index].isEdit =
        !this.listProductInCombo[index].isEdit;

      ApiService.post('combos/', data)
        .then(({ data }) => {
          if (data.status === 1) {
            this.makeToastSuccess(data.message);
            this.getListProductInCombo();
          } else {
            this.makeToastFaile(data.message);
          }
        })
        .catch(({ response }) => {
          this.makeToastFaile(response.$error);
        });
    },
    createChildProduct() {
      if (this.selectedType === PRODUCT_TYPE_ENUM.CHASSIS_ENGINE) {
        if (
          (!this.form.code && !this.childCode) ||
          !this.colorChildExterior ||
          !this.childVersion
        ) {
          this.makeToastFaile('Vui lòng nhập mã sản phẩm, màu sắc, phiên bản!');
          return;
        }
      }
      if (
        this.selectedType === PRODUCT_TYPE_ENUM.SERIES ||
        this.selectedType === PRODUCT_TYPE_ENUM.DEFAULT
      ) {
        if ((!this.form.code && !this.childCode) || !this.colorChildExterior) {
          this.makeToastFaile('Vui lòng nhập mã sản phẩm, màu sắc, phiên bản!');
          return;
        }
      }

      if (!this.productIdFromUrl) {
        this.makeToastFaile('Thông tin sản phẩm cha bị sai F5 để cập nhật lại');
        return;
      }
      if (this.sellingChildPrice < 0) {
        this.makeToastFaile('Vui lòng nhập giá bán');
        return;
      }
      // if (!this.colorChildExterior) {
      //   this.makeToastFaile('Vui lòng nhập màu sắc xe');
      //   return;
      // }

      // if (!this.colorChildInterior) {
      //   this.makeToastFaile('Vui lòng nhập màu sắc nội thất');
      //   return;
      // }
      const data = {
        code: removeVietnameseCharactor(
          this.childCode
            ? this.childCode
            : this.$v.form.code.$model +
                '-' +
                this.colorChildExterior +
                (this.childVersion ? '-' + this.childVersion : ''),
        ),
        parentId: this.productIdFromUrl,
        sellingPrice: Number(unMaskPrice(this.sellingChildPrice)),
        version: this.childVersion || null,
        colorExterior: this.colorChildExterior,
        colorInterior: this.colorChildInterior,
      };
      ApiService.post('products/child', data)
        .then(() => {
          this.getProductById();
          this.childVersion = null;
          this.colorChildExterior = null;
          this.colorChildInterior = null;
          this.sellingChildPrice = 0;
          this.childrens = [];
        })
        .catch(({ response }) => {
          const error =
            response.data.message ?? 'Lỗi hệ thống vui lòng thử lại sau';
          this.makeToastFaile(error);
        });
      this.hideModalAddProduct();
    },

    searchProduct: async function (textSearch) {
      const param = {
        name: textSearch,
      };

      const paramQuery = {
        params: param,
      };
      ApiService.query('product/searchProductByName', paramQuery).then(
        (response) => {
          this.options[0].data = [];
          response.data.data.forEach((item) => {
            item.productCode = item.productCode ? item.productCode : '';
            let suggestionName = item.productName;
            if (item.productCode !== '') {
              suggestionName = item.productCode + ' - ' + item.productName;
            }
            const product = {
              id: item.id,
              name: item.productName,
              code: item.productCode,
              suggestionName: suggestionName,
            };

            this.options[0].data.push(product);
          });
          this.filteredOptions = [...this.options[0].data];
        },
      );
    },

    onSelectType() {
      if (this.selectedType !== this.productType.PRODUCT_COMBO) {
        this.showCombo = false;
        return;
      }
      this.genChildProduct();
      this.showCombo = true;
    },

    async onClickToUpdate() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const content = {
        title: `Cập nhật sản phẩm`,
        text: `Bạn có chắc cập nhật sản phẩm #${this.form.name} không ?`,
        actionName: 'Xác nhận',
        confirmButtonColor: '#3699FF',
      };
      const result = await this.showConfirmNotify(content);
      if (!result.value) return;

      const productName = this.$v.form.name.$model
        ? this.$v.form.name.$model.trim()
        : null;

      const productCode = this.$v.form.code.$model
        ? this.$v.form.code.$model.trim()
        : null;

      if (!productName) {
        this.makeToastFaile('Vui lòng nhập tên sản phẩm!');
        return;
      }

      if (!productCode) {
        this.makeToastFaile('Vui lòng nhập mã sản phẩm!');
        return;
      }

      if (!this.selectedCateId) {
        this.makeToastFaile('Vui lòng chọn danh mục sản phẩm!');
        return;
      }

      if (!this.selectedBrand) {
        this.makeToastFaile('Vui lòng chọn thương hiệu!');
        return;
      }

      const data = {
        id: this.productIdFromUrl,
        name: this.form.name,
        categoryId: this.selectedCateId,
        brandId: this.selectedBrand,
        importPrice: Number(this.originalPrice),
        sellingPrice: Number(this.salePrice ? unMaskPrice(this.salePrice) : 0),
        // vehicleTypeId:this.
        version: this.version,
        vatType: this.form.productVat,
        uomId: this.form.unitId,
        colorExterior: this.colorExterior,
        colorInterior: this.colorInterior,
        deleted: this.selectedStatus,
        productCodeVat: this.productCodeVat?.trim() || null,
        productNameVat: this.productNameVat?.trim() || null,
      };
      ApiService.put('products/', data)
        .then(({ data }) => {
          this.makeToastSuccess(data.message);
          setTimeout(() => {
            this.$router.push({
              path: '/products',
            });
          }, TIME_TRIGGER);
        })
        .catch((error) => {
          if (error.response) {
            return this.makeToastFaile(
              error.response.data
                ? error.response.data.message
                : 'Có vấn đề xảy ra hãy thử lại',
            );
          }
          return this.makeToastFaile(
            error.message || error || 'Có vấn đề xảy ra hãy thử lại',
          );
        });
    },

    getProductById() {
      this.listProducts = [];
      this.isShowImportPrice = this.checkPermission(
        'PRODUCT_ORIGINAL_PRICE_VIEW',
      );
      ApiService.get(`products/${this.productIdFromUrl}`)
        .then(({ data }) => {
          this.idSync = data.data.idSync;

          this.form.unitId = data.data.uomId || null;
          // this.isEditedProductCode = data.data.isEditedProductCode;
          this.selectedCateId = data.data.categoryId;
          // this.selectedExternalCateId = data.data.productWebCategory;
          // this.form.selectedCate = data.data.category.name;
          this.form.selectedCate = data.data.categoryId;
          // this.form.selectedExternalCate = data.data.productExternalCateName;
          this.form.name = data.data.name;
          this.form.code = data.data.code;
          this.note = data.data.note;
          this.parentId = data.data.parentId || null;
          this.selectedType = data.data.type;
          this.productCodeVat = data.data.productCodeVat;
          this.productNameVat = data.data.productNameVat;
          // this.productTradeName = data.data.productTradeName;
          // this.productBrandCode = data.data.productBrandCode;
          this.importPrice = this.isShowImportPrice ? data.data.importPrice : 0;
          this.originalPrice = data.data.importPrice;
          this.importChildPrice = data.data.importPrice;
          this.salePrice = data.data.sellingPrice;
          this.colorExterior = data.data.colorExterior;
          this.colorInterior = data.data.colorInterior;
          this.version = data.data.version;

          this.unitMulti = data.data.uomMulti.map((item) => {
            return {
              id: item['uomId'],
              label: `${item['uom']['name']} - ${item['conversionRate']}`,
              uomMultiId: item['id'],
            };
          });
          this.unitMultiOptions = cloneDeep(this.unitOptions);
          if (this.unitMultiOptions.length) {
            const object = keyBy(this.unitMulti, 'id');
            this.unitMultiOptions = this.unitMultiOptions.map((item) => {
              if (object[item['id']]) {
                item['label'] = object[item['id']]['label'];
              }
              return item;
            });
          }

          this.selectedStatus = data.data.deleted;

          this.form.searchBrandName = data.data.brand
            ? data.data.brand.name
            : '';
          this.selectedBrand = data.data.brandId;

          this.form.productVat = data.data.vatType;

          if (data.data.children.length) {
            let count = 0;
            for (const item of data.data.children) {
              count += 1;
              this.childrens.push({
                count: count,
                code: item['code'],
                name: item['name'],
                importPrice: item['importPrice'],
                sellingPrice: item['sellingPrice'],
                deleted: item['deleted'],
              });
            }
          }
        })
        .catch(() => {
          this.makeToastFaile('Lỗi');
        });
    },

    // getProductById() {
    //   this.listProducts = [];
    //   ApiService.get(`product/${this.productIdFromUrl}`)
    //     .then(({ data }) => {
    //       this.form.unitId = data.data.unitId || null;
    //       this.isEditedProductCode = data.data.isEditedProductCode;
    //       this.selectedCateId = data.data.productCategory;
    //       this.selectedExternalCateId = data.data.productWebCategory;
    //       this.form.selectedCate = data.data.productCateName;
    //       this.form.selectedExternalCate = data.data.productExternalCateName;
    //       this.form.name = data.data.productName;
    //       this.form.code = data.data.productCode;
    //       this.note = data.data.note;
    //       this.productCodeVat = data.data.productCodeVat;
    //       this.productNameVat = data.data.productNameVat;
    //       this.productTradeName = data.data.productTradeName;
    //       this.productBrandCode = data.data.productBrandCode;
    //       this.alias = data.data.alias;
    //       this.returnSellingPrice =
    //         data.data.returnSellingPrice !== null
    //           ? data.data.returnSellingPrice
    //           : 0;
    //       this.unit = data.data.unit;
    //       this.selectedClassParent = data.data.parentProductId;
    //       this.selectedParent = data.data.parentProductName;
    //       this.barcode = data.data.barCode;
    //       this.selectedOriginal = data.data.original;
    //       this.selectedBrand = data.data.brand;
    //       this.selectedType = data.data.productType;
    //       this.warrantyAddress = data.data.warrantyAddress;
    //       this.warrantyPhone = data.data.warrantyPhone;
    //       this.warrantyMonthNo = data.data.warrantyMonthNo;
    //       this.warrantyDescription = data.data.warrantyDescription;
    //       this.importPrice = data.data.originalPrice;
    //       this.salePrice = data.data.sellingPrice;
    //       this.wholesalePrice = data.data.wholesalePrice;
    //       this.form.listedPrice = data.data.listedPrice;
    //       this.width = data.data.width;
    //       this.length = data.data.length;
    //       this.weight = data.data.weight;
    //       this.height = data.data.height;
    //       this.selectedColor = data.data.listColor;
    //       this.selectedColorOriginal = data.data.listColor.map((a) =>
    //         Object.assign({}, a),
    //       );
    //       this.selectedSize = data.data.listSize;
    //       this.selectedSizeOriginal = data.data.listSize.map((a) =>
    //         Object.assign({}, a),
    //       );
    //       this.selectedStatus = data.data.status;
    //       if (this.selectedType === this.productType.PRODUCT_COMBO) {
    //         this.showCombo = true;
    //         const productComboData = data.data.listProductInCombo;

    //         this.listProductInCombo = productComboData.map((item) => {
    //           return { ...item, isEdit: false };
    //         });
    //       } else {
    //         this.getListProductChild();
    //       }
    //       const brand = this.listBrand.find(
    //         (brand) => brand.id === this.selectedBrand,
    //       );
    //       this.form.searchBrandName = brand ? brand.name : '';
    //       this.form.productVat = data.data.productVat;
    //     })
    //     .catch(() => {
    //       this.makeToastFaile('Lỗi');
    //     });
    // },

    getListProductChild() {
      this.listProducts = [];
      ApiService.get(`product/get-list-child/${this.productIdFromUrl}`).then(
        (response) => {
          let count = 1;
          response.data.data.forEach((item) => {
            let product = {
              count: count,
              ...item,
            };
            count++;
            this.listProducts.push(product);
          });
        },
      );
    },
    onSelected(option) {
      this.selectedClassParent = option.item.id;
      let name = option.item.name;
      if (option.item.code !== '') {
        name = option.item.code + ' - ' + option.item.name;
      }
      this.selectedParent = name;
      this.genChildProduct();
    },
    onSelectedCate(option) {
      this.selectedCateId = option.item.id;
      this.form.selectedCate = option.item.name;
    },
    onInputChange(text) {
      this.selectedParent = text;

      this.debounceInputSearchProduct();
      this.genChildProduct();
    },
    onInputChangeProductCombo(text) {
      this.searchProductForCombo = text;

      this.debounceInputSearchProductCombo();
    },
    onInputCateChange(text) {
      this.form.selectedCate = text;

      const filteredData = this.cateOptions
        .filter((item) => {
          return (
            removeAccents(item.name)
              .toLowerCase()
              .indexOf(removeAccents(text.toLowerCase())) > -1
          );
        })
        .slice(0, this.limit);

      this.filteredCateOptions = [...filteredData];
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.name;
    },
    getListExternalCate: function () {
      const param = {
        page: 1,
        limit: 1000,
        name: '',
        code: '',
      };
      const paramQuery = {
        params: param,
      };
      ApiService.query('productExternalCategory', paramQuery).then(
        ({ data }) => {
          this.numberOfPage = data.data.total_page;
          data.data.list_caterogy.forEach((element) => {
            let name = '';
            if (element.level === 1) {
              name = '-' + element.name;
            } else if (element.level === 2) {
              name = '--' + element.name;
            } else if (element.level === 3) {
              name = '---' + element.name;
            } else if (element.level === 4) {
              name = '----' + element.name;
            } else if (element.level === 5) {
              name = '-----' + element.name;
            } else if (element.level === 6) {
              name = '------' + element.name;
            } else {
              name = element.name;
            }
            let item = {
              id: element.id,
              name: element.name,
              suggestionName: name,
            };
            this.externalCateOptions.push(item);
          });
          this.filteredExternalCateOptions = [...this.externalCateOptions];
        },
      );
    },
    onSelectedExternalCate(option) {
      this.selectedExternalCateId = option.item.id;
      this.form.selectedExternalCate = option.item.name;
    },
    onInputExternalCateChange(text) {
      this.form.selectedExternalCate = text;

      const filteredData = this.externalCateOptions
        .filter((item) => {
          return (
            removeAccents(item.name)
              .toLowerCase()
              .indexOf(removeAccents(text.toLowerCase())) > -1
          );
        })
        .slice(0, this.limit);

      this.filteredExternalCateOptions = [...filteredData];
    },
    onSelectedProductForCombo(option) {
      this.selectedProductForCombo.id = option.item.id;
      this.selectedProductForCombo.name = option.item.name;
      this.selectedProductForCombo.code = option.item.code;
      this.searchProductForCombo = option.item.name;
    },
    debounceInputSearchProduct: debounce(function () {
      this.searchProductAPI(1);
    }, TIME_TRIGGER),
    debounceInputSearchProductCombo: debounce(function () {
      this.searchProductAPI(2);
    }, TIME_TRIGGER),
    searchProductAPI(type) {
      if (!this.isSearching) {
        let textSearch = '';
        if (type === 1) {
          textSearch = this.selectedParent ? this.selectedParent.trim() : '';
        } else if (type === 2) {
          textSearch = this.searchProductForCombo
            ? this.searchProductForCombo.trim()
            : '';
        }
        this.searchProduct(textSearch);
      }
    },
    getHistoryByProductId() {
      this.histories = [];
      ApiService.get(`product/histories/${this.productIdFromUrl}`)
        .then(({ data }) => {
          if (data.status === 1) {
            this.histories = data.data;
          } else {
            this.makeToastFaile('Tải dữ liệu thất bại!');
          }
        })
        .catch(() => {
          this.makeToastFaile('Lỗi');
        });
    },
    viewHistoryDetail(id) {
      const item = this.histories.find((x) => x.id === id);
      this.history = item ? item : this.history;
      this.$refs['history-modal'].show();
    },
    showDeleteAlert: function (item) {
      Swal.fire({
        title: 'Xóa sản phẩm!',
        text: 'Bạn có chắc muốn xóa sản phẩm này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        position: 'top',
      }).then((result) => {
        if (result.dismiss != 'cancel') {
          const filteredProducts = this.listProductNew.filter((product) => {
            return product.id == item.id;
          });
          this.listProductNew = [].concat(filteredProducts);
        }
      });
    },
    onSelectedBrand(option) {
      this.selectedBrand = option.item.id;
      this.form.searchBrandName = option.item.name;
    },
    onInputBrandChange(text) {
      this.form.searchBrandName = text;

      const filteredData = this.brandOptions
        .filter((item) => {
          return (
            removeAccents(item.name)
              .toLowerCase()
              .indexOf(removeAccents(text.toLowerCase())) > -1
          );
        })
        .slice(0, this.limit);

      this.filteredBrandOptions = [...filteredData];
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>
<style lang="scss">
.edit-product {
  .border-grey {
    border-color: #e5eaee !important;
  }
  .input-group-append {
    cursor: pointer;
  }

  .input-group-append:hover i {
    color: #3699ff;
  }
  .multi-select-wrapper,
  .auto-autosuggest-wrap-component {
    flex: 1 1 auto;
  }
  .inputText {
    width: 22%;
  }
  .icon:hover {
    background-color: #90c6fc;
  }

  .card-header-tabs {
    margin-right: -21px !important;
    margin-left: -21px !important;
  }

  .full-width .nav-tabs .nav-item {
    margin-bottom: -1px;
    flex-grow: 1 !important;
    text-align: center !important;
  }
  input::-webkit-calendar-picker-indicator {
    display: none;
  }
  .label-header-form {
    font-size: 16px;
  }

  .form-group label {
    font-weight: 500;
  }
  .lable-sp {
    font-weight: 500;
  }

  .orderCode:hover {
    text-decoration: underline;
  }

  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: middle;
    border-top: 1px solid #ecf0f3;
  }
  .table.b-table.table-sm
    > thead
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left),
  .table.b-table.table-sm
    > tfoot
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left) {
    background-position: right calc(1.5rem / 2) center;
    padding-right: calc(0.3rem + 0.65em);
  }
}
</style>
